<template>
    <div v-if="show || image" class="quiz-creator-image-box">
        <h3 v-if="title" class="quiz-title m-0 shadow-text-none">{{ title }}</h3>
        <div
            :id="id"
            :class="{
                'image-box mx-auto mt-4 overflow-hidden relative': true,
                'is-loading': uploadingImage
            }"
            :style="`color:${color};border-color:${borderColor};border-style:${borderStyle}`"
        >
            <div
                v-if="image"
                :style="{ 'background-image': `url(${image})`, filter: `brightness(${100 - darken}%) blur(${blur}px)` }"
                class="image w-full h-full absolute"
            ></div>

            <div
                v-else
                v-html="placeholder"
                @click="openUploadMedia()"
                class="flex justify-center items-center w-full h-full font-size-14 text-center font-bold shadow-text-none cursor-pointer"
            ></div>

            <template v-if="showTool && image">
                <div class="remove-image-icon absolute cursor-pointer" @click="removeImage()">
                    <i class="fas fa-times-circle text-white text-xl"></i>
                </div>

                <div class="flex absolute image-tool">
                    <div
                        v-if="!isGif"
                        v-tippy="{ placement: 'top-center', arrow: true, arrowType: 'round', animation: 'fade' }"
                        @click="openUploadMedia(true)"
                        :content="$t('setting_popup_edit_crop')"
                        class="tool-icon relative"
                        target="_blank"
                    >
                        <i class="fas fa-pen"></i>
                    </div>

                    <a
                        v-if="imageSource"
                        v-tippy="{ placement: 'top-center', arrow: true, arrowType: 'round', animation: 'fade' }"
                        :href="imageSource"
                        :content="$t('setting_popup_image_source', { path: setNewSoureURL(imageSource) })"
                        class="tool-icon relative"
                        target="_blank"
                    >
                        <i class="fas fa-exclamation"></i>
                    </a>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import quizImagePickerMixin from '@/mixins/quiz-image-picker'

export default {
    mixins: [quizImagePickerMixin],

    props: {
        alreadyShow: {
            type: Boolean,
            default: false
        },

        id: {
            type: String,
            default: null
        },

        title: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: '#000'
        },

        borderColor: {
            type: String,
            default: '#000'
        },

        borderStyle: {
            type: String,
            default: 'solid'
        },

        questionIndex: {
            type: Number,
            default: null
        },

        answerIndex: {
            type: Number,
            default: null
        },

        location: {
            type: String,
            defauld: ''
        },

        image: {
            type: String,
            default: null
        },

        imageOriginal: {
            type: String,
            default: null
        },

        imageSource: {
            type: String,
            default: null
        },

        imageCoordinates: {
            type: [Object, Array, String],
            default: null
        },

        blur: {
            type: [String, Number],
            default: 0
        },

        darken: {
            type: [String, Number],
            default: 0
        },

        showTool: {
            type: Boolean,
            default: true
        },

        placeholder: {
            type: String,
            default: null
        }
    }
}
</script>

<style lang="scss">
.quiz-creator-image-box {
    .quiz-title {
        text-transform: capitalize;
    }

    .image-box {
        max-width: 200px;
        width: 50%;
        height: auto;
        aspect-ratio: 1 / 1;
        border-radius: 0.25rem;

        .image {
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
        }

        .remove-image-icon {
            top: 0.25rem;
            right: 0.25rem;

            i {
                text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
            }
        }

        .image-tool {
            bottom: 0.25rem;
            right: 0.25rem;
            column-gap: 0.25rem;
        }
    }
}
</style>
